import { createApp } from 'vue';
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import './index.css';
import App from './App.vue';
import router from './router';

// Icons are now bundled at compile time via unplugin-icons
// No runtime initialization needed - see vite.config.ts

// Initialize the app
const app = createApp(App);

// Configure Pinia with persistence
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

// Register plugins
app.use(pinia);
app.use(router);

// Mount the app
// Note: Retry logic is handled by useRetryPendingOperations() composable
// which should be called in App.vue or main layout component
app.mount('#app');
